import type { JSX } from "react";
import { ShieldCheck } from "lucide-react";

import { SECURITY_INVARIANTS } from "./securityInvariants";

/** SECURITY-PAGE-TRUTH-1 (TR-2026-10-16-8 A5) — see securityInvariants.ts for the inclusion rule. */
export function SecurityInvariantsTab(): JSX.Element {
  return (
    <div className="mt-2 max-w-2xl rounded-lg border border-gray-200 bg-white p-5">
      <h2 className="text-sm font-semibold text-gray-900">Always enforced</h2>
      <p className="mt-1 text-xs text-gray-500">These rules apply to everyone and can't be turned off.</p>
      <ul aria-label="Always enforced" className="mt-4 space-y-3">
        {SECURITY_INVARIANTS.map((inv) => (
          <li key={inv.id} className="flex items-start gap-2 text-sm text-gray-700">
            <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
            <span>{inv.statement}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
